type MetaInput = {
  title?: string;
  description?: string;
  url?: string;
  image?: string;
  locale?: string;
  type?: string;
};

function upsertMeta(selector: string, attrs: Record<string, string>, content?: string) {
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement('meta');
    Object.entries(attrs).forEach(([k, v]) => el!.setAttribute(k, v));
    document.head.appendChild(el);
  }
  if (content != null) el.setAttribute('content', content);
}

function upsertLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function setMetaTags({ title, description, url, image, locale, type = 'website' }: MetaInput) {
  if (title) document.title = title;
  if (description) upsertMeta('meta[name="description"]', { name: 'description' }, description);

  if (url) upsertLink('canonical', url);

  if (title) upsertMeta('meta[property="og:title"]', { property: 'og:title' }, title);
  if (description) upsertMeta('meta[property="og:description"]', { property: 'og:description' }, description);
  if (url) upsertMeta('meta[property="og:url"]', { property: 'og:url' }, url);
  if (image) upsertMeta('meta[property="og:image"]', { property: 'og:image' }, image);
  upsertMeta('meta[property="og:type"]', { property: 'og:type' }, type);
  if (locale) upsertMeta('meta[property="og:locale"]', { property: 'og:locale' }, locale);

  if (title) upsertMeta('meta[name="twitter:title"]', { name: 'twitter:title' }, title);
  if (description) upsertMeta('meta[name="twitter:description"]', { name: 'twitter:description' }, description);
  upsertMeta('meta[name="twitter:card"]', { name: 'twitter:card' }, image ? 'summary_large_image' : 'summary');
  if (image) upsertMeta('meta[name="twitter:image"]', { name: 'twitter:image' }, image);
}

export function setJsonLd(obj: unknown) {
  const prev = document.head.querySelector('script[data-acquiz-jsonld="1"]');
  if (prev) prev.remove();
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.setAttribute('data-acquiz-jsonld', '1');
  script.textContent = JSON.stringify(obj);
  document.head.appendChild(script);
}
